import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width={20}
    height={19}
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M17.1744 18.1157C16.7939 18.6964 16.1331 19.0369 15.4323 18.9968C14.7314 18.9568 13.8303 18.8566 13.2095 18.6964C10.4461 17.9756 7.58264 16.2535 5.15968 13.8305C2.73671 11.4075 1.0146 8.54402 0.293713 5.78064C0.133517 5.15988 0.0534185 4.2788 -0.00665507 3.57794C-0.0467041 2.89711 0.273698 2.23631 0.854409 1.85584L3.31742 0.213827C3.95821 -0.206687 4.81926 0.0135748 5.15968 0.694408L7.16213 4.55915C7.44247 5.09981 7.3023 5.78064 6.82171 6.16111L5.01951 7.56283C5.74039 8.90447 6.42122 9.98579 7.74283 11.2874C8.96433 12.5089 10.0256 13.2298 11.4073 13.9707L12.8291 12.1484C13.2095 11.6678 13.8904 11.5076 14.431 11.808L18.3158 13.8105C18.9966 14.1509 19.2169 15.0119 18.7964 15.6527L17.1744 18.1157Z"
      fill="#222A5C"
    />
  </svg>,
  "PhoneFilled"
);
